import styled from '@emotion/styled';
import Paper from '@base/Paper/Paper';
import { mediaQuery, Spacings, Fonts } from '@styles/index';
import Image from '@base/Image';
import Typography from 'aquilla/core/atoms/Typography';

const relationsImage = 'about/relations.png';
const contactUsImage = 'about/contact-us.png';

const Container = styled.div`
  margin-top: ${Spacings.SPACING_28B};
  margin-bottom: 114px;
  grid-column: span 24;
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: ${Spacings.SPACING_3B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_18B};
    margin-bottom: ${Spacings.SPACING_6B};
    grid-template-columns: repeat(1, 1fr);
    grid-gap: ${Spacings.SPACING_6B};
    padding: 0 ${Spacings.SPACING_4B};
  }
`;

const Card = styled(Paper)`
  height: 208px;
  padding: 0px;
  overflow: hidden;
`;

const CardCover = styled.div`
  height: 120px;
  width: 100%;
  position: relative;
  background-color: ${({ $bgColor }) => $bgColor};
  padding: ${Spacings.SPACING_4B};
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`;

const CardImageContainer = styled.div`
  position: absolute;
  left: 0;
  bottom: -3px;
`;

const CardImage = styled(Image)`
  object-fit: contain;
`;

const CardContent = styled.div`
  padding-top: ${Spacings.SPACING_4B};
  padding-left: ${Spacings.SPACING_4B};
`;

const Description = styled(Typography)`
  font-weight: ${Fonts.LIGHT};
  color: var(--color-text-secondary);
  ${mediaQuery.uptoTablet} {
    font-size: ${Fonts.LARGE};
  }
`;

const StyledLink = styled.a`
  color: var(--color-i-green);
  text-decoration: none;
`;

const cardsInfo = [
  {
    id: 1,
    title: 'Public relations',
    subTitle: 'For media enquiry email us at ',
    linkContent: 'press@unacademy.com',
    linkPosition: 'end',
    link: 'mailto:press@unacademy.com',
    bgColor: 'var(--color-i-green)',
    image: { src: relationsImage, width: 106, height: 106 }
  },
  {
    id: 2,
    title: 'Contact us',
    subTitle: 'Shoot your questions to us at ',
    linkContent: 'help@unacademy.com',
    linkPosition: 'end',
    link: 'mailto:help@unacademy.com',
    bgColor: 'var(--color-i-blue)',
    image: { src: contactUsImage, width: 128, height: 96 }
  }
];

function ConcatString({ card: _card }) {
  if (_card.link && _card.linkPosition && _card.linkContent) {
    if (_card.linkPosition === 'start')
      return (
        <>
          <StyledLink href={`${_card.link}`}>{_card.linkContent}</StyledLink>
          {_card.subTitle}
        </>
      );
    return (
      <>
        {_card.subTitle}
        <StyledLink href={`${_card.link}`}>{_card.linkContent}</StyledLink>
      </>
    );
  }
  return _card.subTitle;
}

const LeaderBlock = () => {
  return (
    <Container>
      {cardsInfo.map((_card) => (
        <Card key={_card.id}>
          <CardCover $bgColor={_card.bgColor}>
            <CardImageContainer>
              <CardImage
                src={_card.image.src}
                alt={_card.title}
                width={_card.image.width}
                height={_card.image.height}
              />
            </CardImageContainer>
            <Typography variant="h3" color="var(--color-i-white)">
              {_card.title}
            </Typography>
          </CardCover>
          <CardContent>
            <Description variant="h5">
              <ConcatString card={_card} />
            </Description>
          </CardContent>
        </Card>
      ))}
    </Container>
  );
};

export default LeaderBlock;
